import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=23b3f53c&lang=pug"
import script from "./SendMessageModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports